import React from 'react';
import logo from '../../../assets/images/logo-avatar.svg';

export default function LocalLogo(props) {
  return <img src={logo} alt="LOGO" className="header-logo" {...props} />;
}
